export default "__VITE_ASSET__D1$5lGSs__"